(function ($) {
    $(document).ready(function () {
        var sections = $('.section.faq_section');
        sections.each(function () {
            var section = $(this);
            var groups = section.find('.faq_group');
            groups.each(function () {
                var group = $(this);
                var groupBtn = group.find('.group_title');
                var faqBtn = group.find('.faq .title');
                var groupHeight = 0;

                groupBtn.click(function () {
                    var mainBtn = $(this);
                    var hiddencontent = mainBtn.parent().find('> .hidden_description');
                    groupHeight = hiddencontent.find('> .inner_wrap').outerHeight(true);
                    if (!mainBtn.hasClass('open')) {
                        hiddencontent.css({
                            height: groupHeight
                        });
                        group.addClass('expanded');
                        mainBtn.addClass('open');
                        mainBtn.attr('aria-expanded',true);
                        faqBtn.removeAttr('tabindex');
                    } else {
                        hiddencontent.css({
                            height: 0
                        });
                        mainBtn.removeClass('open');
                        groupBtn.parent().find('.faq_hidden_description').css({
                            height: 0
                        });
                        groupBtn.parent().find('.faq_title').removeClass('open');
                        group.removeClass('expanded');
                        mainBtn.attr('aria-expanded',false);
                        faqBtn.attr('tabindex',-1);
                    }
                });

                faqBtn.click(function () {
                    var btn = $(this);
                    var siblings = btn.parent().siblings('.faq');
                    var hiddencontent = btn.parent().find('> .hidden_description');
                    var hiddencontentHeight = hiddencontent.find('> .inner_wrap').outerHeight(true);

                    var thisGroupHeight = btn.closest('.faq_group').find('.group_inner_wrap').outerHeight(true);

                    var heightOfBoxesToClose = 0;

                    group.find('.faq .title.open').each(function () {
                        heightOfBoxesToClose +=  $(this).parent().find('> .hidden_description').outerHeight(true);
                    });


                    faqBtn.parent().find('> .hidden_description').css({
                        height: 0
                    });

                    if (!btn.hasClass('open')) {
                        hiddencontent.css({
                            height: hiddencontentHeight
                        });
                        btn.closest('.group_hidden_description').css({
                            height: thisGroupHeight + hiddencontentHeight - heightOfBoxesToClose
                        });
                        btn.addClass('open');
                        btn.attr('aria-expanded',true);
                    } else {
                        btn.closest('.group_hidden_description').css({
                            height: thisGroupHeight - hiddencontentHeight
                        });
                        btn.removeClass('open');
                        btn.attr('aria-expanded',false);
                    }

                    if(siblings.find('.faq_title').hasClass('open')){
                        siblings.find('.faq_title').removeClass('open');
                        siblings.closest('.group_hidden_description').css({
                            height: thisGroupHeight + hiddencontentHeight - heightOfBoxesToClose
                        });
                    }
                });

            });

        });
    });
})(jQuery);
